import React from "react";
import "./Main.css";
import Section1 from "../section1/Section1";
import Section2 from "../section2/Section2";
import Section3 from "../section3/Section3";
import Section4 from "../section4/Section4";
import Section5 from "../section5/Section5";

function Main() {
  return (
    <main>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </main>
  );
}

export default Main;
